module.exports = __webpack_public_path__ + "img/SWS_collections_2022_55.00d55760.jpeg";